import "core-js/modules/es.array.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { getInfo, getBtnAuthMenu, getImBtnAuthMenu, getBtnAuthList } from '@/api/User/user';
import { getToken, setToken, removeToken } from '@/utils/cookies';
import router, { resetRouter } from '@/router';
import { getTargetInTreeData } from '@/utils/common';
// 查询页面的按钮权限
function getBtnAuth(functionCode) {
  return new Promise(resolve => {
    getBtnAuthMenu(functionCode).then(res => {
      resolve(res);
    });
  });
}
// 查询页面的按钮权限
function getBielBtn() {
  return new Promise(resolve => {
    getBtnAuthList().then(res => {
      resolve(res);
    });
  });
}
function getImBtnAuth(functionCode) {
  return new Promise(resolve => {
    getImBtnAuthMenu(functionCode).then(res => {
      resolve(res);
    });
  });
}
export default {
  namespaced: true,
  state: () => ({
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    username: '',
    roles: [],
    allInfo: {},
    functionCode: '',
    authBtns: [],
    imAuthBtns: '*'
    // imAuthBtns: process.env.NODE_ENV === 'development' ? '*' : []
  }),
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_USERNAME(state, username) {
      state.username = username;
    },
    SET_ALLINFO(state, allInfo) {
      state.allInfo = allInfo;
    },
    SET_AUTHBTNS(state, authBtns) {
      state.authBtns = authBtns;
    },
    SET_FUNCTIONCODE(state, functionCode) {
      state.functionCode = functionCode;
    },
    SET_IMAUTHBTNS(state, authBtns) {
      state.imAuthBtns = authBtns;
    }
  },
  actions: {
    // get user info
    getInfo({
      commit,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const {
            roles,
            name,
            introduction,
            username,
            ButtonCode
          } = response;
          commit('SET_ALLINFO', response);
          localStorage.setItem('ButtonCode', ButtonCode);
          localStorage.setItem('CsUsername', response.username);
          dispatch('getUserName');
          commit('SET_ROLES', roles);
          commit('SET_NAME', name);
          const userImageUrl = `https://yb.countrygarden.com.cn/gateway/SecondProject/user/info?user=${username || null}&size=90`;
          commit('SET_AVATAR', userImageUrl);
          commit('SET_INTRODUCTION', introduction);
          commit('SET_USERNAME', username);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    setAuthBtns({
      commit
    }, {
      path,
      functionCode
    }) {
      // functionCode: 1.业务页面自主传值； 2.根据路由寻找对应值
      return new Promise(async resolve => {
        const menus = localStorage.getItem('menus');
        // if (!functionCode) {
        //   functionCode = getTargetInTreeData(
        //     JSON.parse(menus),
        //     'functionUri',
        //     path
        //   )?.functionCode
        // }
        // if (!functionCode) {
        //   // 当前路由不存在于权限列表内
        //   return resolve(1)
        // }
        const res = await getBielBtn(); // 查询页面的按钮权限
        const authedBtns = res.d.results;
        commit('SET_FUNCTIONCODE', functionCode); // 增加标识页面权限code字段
        commit('SET_AUTHBTNS', authedBtns);
        resolve(1);
      });
    },
    setIMAuthBtns: async ({
      commit,
      state
    }, path) => {
      let functionCode = '';
      if (path.startsWith('/im/contract-payment-plan-search') || path.startsWith('/projectDetail/contract')) {
        functionCode = 'ZY-057';
      } else if (path.startsWith('/im/payment-request-index') || path.startsWith('/projectDetail/payment')) {
        functionCode = 'ZY-056';
      }
      if (state.imAuthBtns === '*') return;
      const res = await getImBtnAuth(functionCode);
      commit('SET_IMAUTHBTNS', res);
      return true;
    },
    findPageAuth({
      commit
    }, path) {
      return new Promise(async resolve => {
        const menus = localStorage.getItem('menus');
        let functionCode = getTargetInTreeData(JSON.parse(menus), 'functionUri', path)?.functionCode;
        if (path.includes('/dashboard')) {
          functionCode = 'dashboard';
        }
        if (functionCode) {
          return resolve(1); // TODO -- 后台录取所有子集页面
        }
        return resolve(5); // TODO -- 无权
      });
    },
    // remove token
    resetToken({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        removeToken();
        resolve(true);
      });
    },
    // dynamically modify permissions
    changeRoles({
      dispatch,
      commit
    }, role) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
        const token = role + '-token';
        commit('SET_TOKEN', token);
        setToken(token);
        // const { roles } = this.getInfo() as any
        resetRouter();
        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('permission/generateRoutes');
        // dynamically add accessible routes
        accessRoutes && accessRoutes.forEach(route => {
          router.addRoute(route);
        });
        // reset visited views and cached views
        dispatch('tagsView/delAllViews');
        resolve(true);
      });
    }
  }
};